// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"5d51ea6c","349":"3759c02c","453":"afafd036"}[chunkId] + ".chunk.js";
};